import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DconfigCoreSettings } from '../dconfig-core.settings';
import { Observable, of } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private membershipUrlBase = DconfigCoreSettings.API_ENDPOINT + '/Membership';

  constructor(private http: HttpClient) { }

  login(data): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/login', data)
  }

  register(data): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/register', data)
  }

  passwordForgotten(data): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/forgetPassword', data);
  }

  resetpassword(data): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/resetPasswordThroughEmail', data);
  }

  updateUsersFieldsValues(fieldsObj): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/UpdateUsersFieldsValues', fieldsObj);
  }

  getUsers(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/GetContextUsers');
  }

  getUsersByUserName(userName): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getusersbyname?UserName=' + userName);
  }

  createUser(user): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/CreateContextUser', user);
  }

  updateUser(user): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/UpdateContextUser', user);
  }

  resetPassword(user): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/resetPassword', user);
  }

  deleteUser(user): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/DeleteContextUser?UserName=' + user.UserName);
  }

  getUsersFields(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/GetUsersFields');
  }

  updateUsersFields(filedsObj): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/UpdateUsersFields', filedsObj);
  }

  deleteUserField(fieldId): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/DeleteUserField?id=' + fieldId);
  }

  getUsersFieldsValues(id): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/GetUsersFieldsValues?Id=' + id);
  }

  getRoles(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getroles');
  }

  createRole(role): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/createrole', { RoleName: role.Name });
  }

  updateRole(role): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updaterole', { RoleName: role.Name, NewRoleName: role.NewName });
  }

  deleteRole(role): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deleterole?RoleName=' + role.Name);
  }

  getCompanies(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getCompanies');
  }

  createCompany(company): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/createCompany', company);
  }

  updateCompany(company): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updateCompany', company);
  }

  deleteCompany(company): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deleteCompany?Id=' + company.Id);
  }

  addUserToRole(user, role): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/addUserToRole?UserName=' + user.UserName + '&RoleName=' + role.Name, {});
  }

  removeUserFromRole(user, roleName): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/removeUserFromRole?UserName=' + user.UserName + '&RoleName=' + roleName);
  }

  addUserToCompany(companyId, usersIds): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updateCompanyUsers?Id=' + companyId, { UsersIds: usersIds });
  }

  removeUsersFromCompany(companyId, usersId): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deleteCompanyUsers?Id=' + companyId + '&UserId=' + usersId);
  }


  getPrivileges(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getPrivileges');
  }

  createPrivilege(privilege, controllerName, actionName, requestType): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/createPrivilege?PrvController=' + controllerName + '&PrvAction=' + actionName + '&RequestType=' + requestType, privilege);
  }

  updatePrivilege(privilege): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updatePrivilege', privilege);
  }

  deletePrivilege(privilege): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deletePrivilege?Id=' + privilege.Id);
  }

  getSystemControllersTree(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/GetSystemControllersTree');
  }

  addPrivilegeToRole(privilegeId, roleName): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/addPrivilegeToRole?PrivilegeId=' + privilegeId + '&RoleName=' + roleName, {});
  }

  removePrivilegeFromRole(privilegeId, roleName): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/removePrivilegeFromRole?PrivilegeId=' + privilegeId + '&RoleName=' + roleName);
  }

  getContentPrivileges(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getContentPrivileges');
  }

  createContentPrivilege(privilege, contentId): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/createContentPrivilege?ContentId=' + contentId, privilege);
  }

  updateContentPrivilege(privilege): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updateContentPrivilege', privilege);
  }

  deleteContentPrivilege(contentId): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deleteContentPrivilege?ContentId=' + contentId);
  }

  addContentPrivilegeToRole(contentId, roleName): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/addContentPrivilegeToRole?ContentId=' + contentId + '&RoleName=' + roleName, {});
  }

  removeContentPrivilegeFromRole(contentId, roleName): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/removeContentPrivilegeFromRole?ContentId=' + contentId + '&RoleName=' + roleName);
  }

  getContentsTree(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/GetContentsTree');
  }

  getUserFieldEnumsTree(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getUserFieldEnumsTree');
  }

  getUserFieldEnums(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getUserFieldEnums');
  }

  createUserFieldEnum(enumObj): Observable<Object> {
    return this.http.post(this.membershipUrlBase + '/createUserFieldEnum', enumObj);
  }

  updateUserFieldEnum(enumObj): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updateUserFieldEnum', enumObj);
  }

  deleteUserFieldEnum(enumObj): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deleteUserFieldEnum?Id=' + enumObj.Id + "&Name=" + enumObj.Name);
  }

  updateUserFieldEnumValues(id, values): Observable<Object> {
    return this.http.put(this.membershipUrlBase + '/updateUserFieldEnumValues?Id=' + id, values);
  };
  deleteUserFieldEnumValue(id): Observable<Object> {
    return this.http.delete(this.membershipUrlBase + '/deleteUserFieldEnumValue?Id=' + id);
  }

  getUserFieldTypes(): Observable<Object> {
    return this.http.get(this.membershipUrlBase + '/getUserFieldTypes');
  }

  getAllApps(): Observable<Object> {
    return this.http.get('/DConfig/AppsAPI/GetAllApps');
  }
  
  updateAppRoles(id, roles): Observable<Object> {
    return this.http.put('/DConfig/AppsAPI/updateAppRoles?Id=' + id, roles);
  }
}
